export const filterStateConfigs = {
  disabled: {
    name: "disabled",
    type: "danger",
    showTooltip: true
  },
  invalid: {
    name: "invalid",
    type: "warning",
    showTooltip: true
  },
};